import request from '@/api/config/request'

const prex = "api/financeiro/guia";

export function listGuias(eco_codigo, query = {}) {
    return request({
        url: `${prex}/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function guiaDetalhe(dam_hash) {
    return request({
        url: `${prex}/detalhe/${dam_hash}`,
        method: 'get'
    })
}

export function guiaPagamento(dam_hash) {
    return request({
        url: `${prex}/pagamento/${dam_hash}`,
        method: 'get'
    })
}

export function fechamentoParcial(eco_codigo, data) {
    return request({
        url: `${prex}/fechamento_parcial/${eco_codigo}`,
        method: 'post',
        data
    })
}